import { Component } from '@angular/core';

@Component({
  selector: 'app-track-record',
  templateUrl: './track-record.component.html',
  styleUrls: ['./track-record.component.css']
})
export class TrackRecordComponent {

}
